// @flow

import * as React from 'react';
import moment from 'moment';
import { DatePicker } from './inner/DatePicker';
import { Modifiers } from './inner/DatePickerDayModifier';

interface Props {
  date: moment;
  maxDate: moment | void;
  minDate: moment | void;
  onChange: (value: moment) => void;
}

interface State {
  selectedDay: Date | void;
}

export default class SingleDatePicker extends React.Component<Props, State> {

  state = {
    selectedDay: this.props.date.toDate(),
  }

  onDayClick = (day: Date, modifiers: Modifiers) => {
    const { onChange } = this.props;

    if (modifiers.disabled) {
      return;
    }

    this.setState({ selectedDay: day });
    onChange(moment(day));
  }

  renderDay = (day: Date, modifiers: Modifiers) => {
    return day.getDate();
  }

  render() {
    return (
      <DatePicker
        date={this.props.date}
        minDate={this.props.minDate}
        maxDate={this.props.maxDate}
        onChange={this.props.onChange}
        onDayClick={this.onDayClick}
        renderDay={this.renderDay}
        selectedDays={this.state.selectedDay ? [this.state.selectedDay] : []}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ui/datePicker/SingleDatePicker.js